import { configureStore, combineReducers } from "@reduxjs/toolkit";
import currentUserReducer from "./currentUserSlice";
import tabReducer from "./tabSlice";
import testScenarioReducer from "./testScenarioReducers/testScenarioSlice";
import testCaseSetReducer from "./testCaseSetReducers/testCaseSetSlice";
import testRulesReducer from "./testRulesReducers/testRulesSlice";
import testScenarioBuildReducer from "./testScenarioBuildReducers/testScenarioBuildSlice";
import variableSetReducer from "./variableSetReducers/variableSetSlice";
import variableReducer from "./variableReducers/variableSlice";
import testSuiteReducer from "./testSuiteReducers/testSuiteSlice";
import testPlanReducer from "./testPlanReducers/testPlanSlice";
import testSuiteBuildReducer from "./testSuiteBuildReducers/testSuiteBuildSlice";
import testSuitePlanReducer from "./testSuitePlanReducers/testSuitePlanSlice";
import testSuiteScenarioReducer from "./testSuiteScenarioReducers/testSuiteScenarioSlice";
import testPlanBuildReducer from "./testPlanBuildReducers/testPlanBuildSlice";
import buildReportReducer from "./buildReportReducers/buildReportSlice";
import functionReducer from "./functionReducers/functionSlice";
import commonReducer from "reducers/commonSlice";
import collectionForksReducers from "./collectionForksReducers/collectionForksSlice";
import globalErrorSnackbarReducer from "./globalErrorSnackbarReducers/globalErrorSnackbarReducer";
import memoryReducer from "./memoryReducers/memorySlice";
import responseVariableReducer from "./responseVariablesReducers/responseVariableSlice";
import dynamicVariableReducer from "./dynamicVariableReducers/dynamicVariableSlice";

export const RESET_STORE = "RESET_STORE";
const appReducer = combineReducers({
  common: commonReducer,
  user: currentUserReducer,
  tabs: tabReducer,
  testScenario: testScenarioReducer,
  testCaseSet: testCaseSetReducer,
  testRules: testRulesReducer,
  testScenarioBuild: testScenarioBuildReducer,
  variableSet: variableSetReducer,
  variable: variableReducer,
  testSuite: testSuiteReducer,
  testPlan: testPlanReducer,
  testSuiteBuild: testSuiteBuildReducer,
  testSuitePlan: testSuitePlanReducer,
  testSuiteScenario: testSuiteScenarioReducer,
  testPlanBuild: testPlanBuildReducer,
  buildReport: buildReportReducer,
  function: functionReducer,
  collectionForks: collectionForksReducers,
  globalErrorSnackbar: globalErrorSnackbarReducer,
  memory: memoryReducer,
  responseVariables: responseVariableReducer,
  dynamicVariable: dynamicVariableReducer,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: [
          "payload.headers",
          "payload.config",
          "payload.request",
          "payload.response",
        ],
      },
    }),
});

export default store;
